import { FC, useCallback } from 'react';
import { Surface } from '@jsplumbtoolkit/browser-ui-react';
import { Button, Slider } from 'antd';
import { Icons } from 'icons';

import { classnames } from 'lib/classnames';

import styles from './index.module.less';

const cx = classnames(styles);
const AddGrayIcon = Icons['Add-gray'];
const MinusGrayIcon = Icons['Minus-gray'];
interface WorkflowEditorSliderProps {
  surface: Surface;
  zoom: number;
  setZoom: (zoom: number) => void;
}

export const SLIDER_NUM = {
  MAX: 3,
  MIN: 0.5,
  STEP: 0.1,
};

const tooltip = {
  open: false,
};

const WorkflowEditorSlider: FC<WorkflowEditorSliderProps> = ({ zoom, setZoom, surface }) => {
  const onChange = useCallback(
    (value: number) => {
      surface.setZoom(value);
      setZoom(value);
    },
    [setZoom, surface],
  );

  const increase = useCallback(() => {
    let newZoom = zoom + SLIDER_NUM.STEP;
    if (newZoom > SLIDER_NUM.MAX) {
      newZoom = SLIDER_NUM.MAX;
    }
    surface.setZoom(newZoom);
    setZoom(newZoom);
  }, [setZoom, surface, zoom]);

  const decline = useCallback(() => {
    let newZoom = zoom - SLIDER_NUM.STEP;
    if (newZoom < SLIDER_NUM.MIN) {
      newZoom = SLIDER_NUM.MIN;
    }
    surface.setZoom(newZoom);
    setZoom(newZoom);
  }, [setZoom, surface, zoom]);

  return (
    <div className={cx('workflow-editor-slider')}>
      <Button className={cx('slider-minus')} icon={<MinusGrayIcon className={cx('icon')} />} onClick={decline} />
      <span className={cx('slider')}>
        <Slider
          defaultValue={zoom}
          max={SLIDER_NUM.MAX}
          min={SLIDER_NUM.MIN}
          step={SLIDER_NUM.STEP}
          value={zoom}
          onChange={onChange}
          className={cx('slider-content')}
          tooltip={tooltip}
        />
      </span>
      <Button className={cx('slider-add')} icon={<AddGrayIcon className={cx('icon')} />} onClick={increase} />
      <span className={cx('slider-view')}>{Math.round(zoom * 100)}%</span>
    </div>
  );
};

export default WorkflowEditorSlider;
